// Versioning: MAJOR.MINOR are set here, PATCH is derived from the build hash
// injected by Vite at build time (see vite.config.ts).

const MAJOR = 1;
const MINOR = 0;

declare const __APP_BUILD_HASH__: string;
declare const __APP_BUILD_PATCH__: number;
declare const __APP_BUILD_NOTES__: string;

// Fallback values so the app still runs in environments without the Vite
// defines (e.g. some test runners).
const BUILD_HASH =
  typeof __APP_BUILD_HASH__ !== "undefined" ? __APP_BUILD_HASH__ : "dev";
const BUILD_PATCH =
  typeof __APP_BUILD_PATCH__ !== "undefined" ? __APP_BUILD_PATCH__ : 0;
const BUILD_NOTES =
  typeof __APP_BUILD_NOTES__ !== "undefined" ? __APP_BUILD_NOTES__ : "";

export const APP_VERSION = `${MAJOR}.${MINOR}.${BUILD_PATCH}`;
export const APP_BUILD_HASH = BUILD_HASH;
export const APP_BUILD_NOTES = BUILD_NOTES;
